export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-05.jpg'),
        title: 'BIG DATA',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'DATA IS ROOTED IN EVERY CORNER OF OUR LIVES MORE THAN EVER BEFORE.',
      description: `<p style="font-size:1.5rem">Today, data is rooted in every corner of our lives more than ever before. We use data to solve problems, improve welfare, and promote new economic prosperity. With the improvement of data processing capabilities, increase of operation and storage costs and the embedding of various sensing technologies in more and more equipment, data collection, storage and analysis are on an almost infinite upward trend. With the maturity of technology, our equipment, vehicles and rapidly developing "wearable" technology will be able to connect and communicate with each other.</p>
      <p>
Big data acquisition: by breaking through the distributed high-speed reliable data acquisition, high-speed full image and other data acquisition technologies, data is extracted, transformed, loaded, and finally the potential value of the data is mined.
Big data preprocessing: Before data mining, data is processed via data cleaning, data integration, data transformation, data reduction, etc. to improve the quality of data mining and also reduce the time of the data mining process.
Large data management storage and management: Hadoop distributed storage technology is used to improve data storage and management capabilities.
Big data analysis and mining: off-line analysis, quasi-real-time analysis, real-time analysis, image recognition, speech recognition, machine learning; MapReduce, Hive, Pig, Spark, Flink, Impala, Kylin, Tez, Akka, Storm, S4, Mahout, MLlib. Big data presentation and application:
</p>`
    },
    {
      title: 'OUR SERVICES',
      description:`<span class='img' style="background:url(`+require('../../../assets/images/services/pic-05.jpg')+`)"></span>
      <span class="list">
      <i></i>One-stop Development<br/>
      <i></i>Open and flexible<br/>
      <i></i>Mature and stable<br/>
      <i></i>Safety and reliability<br/>
      <i></i>Quality Service
      </span>`
    }
  ]
}
